@let branding = brandingService.branding$ | async;

@if (branding !== null && branding !== undefined) {
    @if (isLearnerMissing) {
        <mm-profile-learner-missing></mm-profile-learner-missing>
    } @else {
        <mm-ranking [darkMode]="(teamsContextService.teamsContext$ | async)?.app.theme === 'dark'"
                    (periodSelected)="periodSelected($event)"
                    [rankingData]="scoreboardData$">
        </mm-ranking>
    }
}
